export const ADD_TO_CART = 'ADD_TO_CART';
export const REMOVE_CART = 'REMOVE_CART';
export const CHANGE_QUANTITY = 'CHANGE_QUANTITY ';
export const CLEAR_CART = 'CLEAR_CART ';

export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE ';
